import { render, staticRenderFns } from "./PermissionsCrud.vue?vue&type=template&id=58ed883e"
import script from "./PermissionsCrud.vue?vue&type=script&lang=js"
export * from "./PermissionsCrud.vue?vue&type=script&lang=js"
import style0 from "./PermissionsCrud.vue?vue&type=style&index=0&id=58ed883e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports